import React from "react";
import { Link } from "react-router-dom";
import DataVizualisation from "./DataVizualisation";

const Home = () => {
  return (
    <div className="homePage">
      <div className="homePageContent">
        <button className="admin_access">
          <Link to="/mint" className="admin_link">
            Administrative Access
          </Link>
        </button>
        <button className="public_access">
          <Link to="/verify" className="public_link">
            Public Access
          </Link>
        </button>
        <DataVizualisation />
      </div>
    </div>
  );
};

export default Home;
